<div mat-dialog-title class="filter-dialog-title">
  <h2>Filter tasks by user</h2>
  <button mat-icon-button matDialogClose="{}" aria-label="close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <mat-form-field class="filter-form-field">
    <mat-label> Search users </mat-label>
    <input
      #filterInput
      class="filter-input"
      matInput
      [matAutocomplete]="userAutocomplete"
      [formControl]="filterControl"
    />
    <mat-autocomplete
      autoActiveFirstOption
      hideSingleSelectionIndicator
      (optionSelected)="setFilter($event.option.value)"
      #userAutocomplete="matAutocomplete"
      class="filter-autocomplete"
    >
      <mat-option
        disabled
        *ngIf="
          !this.filteredUserSelected &&
          filteredUsersRemaining.length === 0 &&
          this.filteredNotInSpaceUsers.length === 0 &&
          !showNoUser &&
          !showClearFilter
        "
      >
        No matching users.
      </mat-option>

      <mat-option
        class="filter-option"
        *ngIf="filteredUserSelected"
        [value]="{ userId: userId }"
      >
        <div class="positioner">
          <div><mat-icon>done</mat-icon></div>
          <div class="name">
            {{ filteredUserSelected.name }}
          </div>
          <div></div>
        </div>
      </mat-option>

      <mat-option
        class="filter-option"
        *ngIf="showNoUser"
        [value]="{ noUser: !noUser }"
      >
        <div class="positioner">
          <div><mat-icon *ngIf="noUser">done</mat-icon></div>
          <div class="name">{{ noUserText }}</div>
          <div></div>
        </div>
      </mat-option>

      <mat-option
        class="filter-option"
        *ngIf="showClearFilter && (filteredUserSelected || noUser)"
        [value]="{ userId: undefined }"
      >
        <div class="positioner">
          <div><mat-icon>close</mat-icon></div>
          <div class="name">{{ clearFilterText }}</div>
          <div></div>
        </div>
      </mat-option>

      <mat-option
        class="filter-option"
        *ngFor="let user of filteredUsersRemaining"
        [value]="{ userId: user._id }"
      >
        <div class="positioner">
          <div></div>
          <div class="name">
            {{ user.name }}
          </div>
        </div>
      </mat-option>

      <mat-option disabled *ngIf="filteredNotInSpaceUsers.length">
        Not in this space
      </mat-option>
      <mat-option
        class="filter-option"
        *ngFor="let user of filteredNotInSpaceUsers"
        [value]="{ userId: user._id }"
      >
        <div class="positioner">
          <div></div>
          <div class="name">{{ user.name }}</div>
          <div></div>
        </div>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</mat-dialog-content>
